import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useGoals } from '../hooks/useGoals';
import { GlassButton } from '../components/GlassButton';
import { GlassCard } from '../components/GlassCard';
import { GoalCard } from '../components/GoalCard';
import { CreateGoalModal } from '../components/CreateGoalModal';
import { LogOut, Plus, Menu, X } from 'lucide-react';
export function Dashboard() {
  const {
    logout
  } = useAuth();
  const {
    goals,
    createGoal,
    calculateDailyTarget,
    calculateProgress
  } = useGoals();
  const [showModal, setShowModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const activeGoals = goals.filter(goal => calculateProgress(goal) < 100);
  const totalDailyTarget = activeGoals.reduce((sum, goal) => sum + calculateDailyTarget(goal), 0);
  const totalDebt = goals.filter(goal => goal.type === 'debt').reduce((sum, goal) => sum + goal.targetAmount, 0);
  const totalSaveGoals = goals.filter(goal => goal.type === 'save').reduce((sum, goal) => sum + goal.targetAmount, 0);
  return <div className="min-h-screen p-4 md:p-8" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        {/* Top Navigation */}
        <GlassCard className="p-4 mb-8 flex items-center justify-between" data-id="element-63">
          <h1 className="text-2xl font-bold text-white" data-id="element-64">SatNak</h1>

          <div className="relative" data-id="element-65">
            <button onClick={() => setShowMenu(!showMenu)} className="p-2 text-white hover:bg-white/10 rounded-lg transition-colors" data-id="element-66">
              {showMenu ? <X size={24} data-id="element-67" /> : <Menu size={24} data-id="element-68" />}
            </button>

            {showMenu && <div className="absolute right-0 mt-2 w-48 backdrop-blur-xl bg-white/10 border border-white/20 rounded-xl shadow-xl overflow-hidden z-50" data-id="element-69">
                <button onClick={() => {
              logout();
              setShowMenu(false);
            }} className="w-full px-4 py-3 text-left text-white hover:bg-white/10 transition-colors flex items-center gap-2" data-id="element-70">
                  <LogOut size={18} data-id="element-71" />
                  Sign Out
                </button>
              </div>}
          </div>
        </GlassCard>

        {/* Stats Display */}
        {goals.length > 0 && totalDailyTarget > 0 && <GlassCard className="p-8 mb-8" data-id="element-72">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-73">
              <div data-id="element-74">
                <p className="text-white/70 text-sm mb-2" data-id="element-75">Total Debt</p>
                <p className="text-4xl font-bold text-white" data-id="element-76">
                  ${totalDebt.toFixed(2)}
                </p>
              </div>

              <div data-id="element-77">
                <p className="text-white/70 text-sm mb-2" data-id="element-78">Total Save Goals</p>
                <p className="text-4xl font-bold text-white" data-id="element-79">
                  ${totalSaveGoals.toFixed(2)}
                </p>
              </div>

              <div data-id="element-80">
                <p className="text-white/70 text-sm mb-2" data-id="element-81">
                  Combined Daily Target
                </p>
                <p className="text-4xl font-bold text-white" data-id="element-82">
                  ${totalDailyTarget.toFixed(2)}
                </p>
                <p className="text-white/60 text-sm mt-2" data-id="element-83">To stay on track</p>
              </div>
            </div>
          </GlassCard>}

        {goals.length === 0 ? <div className="text-center py-20" data-id="element-84">
            <div className="text-6xl mb-4" data-id="element-85">🎯</div>
            <h2 className="text-2xl font-semibold text-white mb-2" data-id="element-86">
              No goals yet
            </h2>
            <p className="text-white/70 mb-6" data-id="element-87">
              Create your first financial goal to get started
            </p>
            <GlassButton onClick={() => setShowModal(true)} variant="primary" data-id="element-88">
              <Plus size={20} className="inline mr-2" data-id="element-89" />
              Create First Goal
            </GlassButton>
          </div> : <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-90">
              {goals.map(goal => <GoalCard key={goal.id} goal={goal} progress={calculateProgress(goal)} dailyTarget={calculateDailyTarget(goal)} data-id="element-91" />)}
            </div>

            <div className="flex justify-center" data-id="element-92">
              <GlassButton onClick={() => setShowModal(true)} variant="primary" data-id="element-93">
                <Plus size={20} className="inline mr-2" data-id="element-94" />
                Add Goal
              </GlassButton>
            </div>
          </>}

        {showModal && <CreateGoalModal onClose={() => setShowModal(false)} onSubmit={createGoal} data-id="element-95" />}
      </div>
    </div>;
}